import { CartBrowsingCriteria, RateSegment } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { getCart } from 'api/operations/cartServiceV2';
import { makeAutoObservable, runInAction } from 'mobx';
import { INITIAL_CART_OBJECT } from 'store/domain/cartStoreV2';
import { Cart } from 'types/cartServiceV2';

export default class CartModule {
  private _cart: Cart = INITIAL_CART_OBJECT;
  private _isLoading: boolean = false;

  public get cart(): Cart {
    return this._cart;
  }

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public setIsLoading(isLoading: boolean): void {
    this._isLoading = isLoading;
  }

  public async getCart(cartId: string): Promise<void> {
    this.setIsLoading(true);
    const cart = await getCart(cartId);
    runInAction(() => {
      this._cart = cart;
      this.setIsLoading(false);
    });
  }

  public get lastUpdateBrowsingCriteria(): CartBrowsingCriteria {
    return this._cart.lastUpdateBrowsingCriteria;
  }

  public get rateSegment(): RateSegment {
    return this._cart.rateSegment;
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
